
<div *ngIf="ms.show_news && this.ms.news.length">
  <w-notification-bar *ngIf="!is_news_closed" [visible]="!is_news_closed" [canClose]="true" (wClosed)="is_news_closed=true" message="{{get_news_for_lang()}}"></w-notification-bar>
</div>
<div class="mainGrid noflex column">
  <wipo-navbar *ngIf="ms.environment.wipoComponentsPath" applicationName="Global Brand Database" [applicationLink]="ms.environment.appUrl" applicationCategory="marks" [language]="ms.lang" login="EVENT" logout="EVENT" [languageOptions]="ms.environment.appLangs" [helpMore]="helpMore" [helpOptions]="helpOptions" appId="app-0018" hide-breadcrumbs="true" hide-top-notch="true" collapse-navigation="true" hide-search="true" [attr.pagekey]="ms.endpoint">
    <div class="placeholder"></div>
  </wipo-navbar>
  <div class="feedback-widget-container" *ngIf="shouldShowFeedbackWidget">
    <div class="feedback-widget-frame">
      <button class="feedback-widget-close" type="button" aria-label="Close survey widget" (click)="dismissFeedbackWidget()">&times;</button>
      <wu-alchemer-widget [attr.url]="feedbackSurvey.url" [attr.label]="feedbackSurvey.label" [attr.text]="feedbackSurvey.text"></wu-alchemer-widget>
    </div>
  </div>
  <ng-template #noMobileVersion>
    <h6 class="noMobileVersion">Sorry, the display isn't wide enough to display the application. Mobile devices aren't supported yet.</h6>
  </ng-template>
  <div class="flex center-h" *ngIf="!hashSearches && captchaService.isCaptchaEnabled; else templateApp">
    <altcha-widget [challengeurl]="captchaService.captchaURL" auto="onload" hidefooter="true" hidelogo="true" (verified)="onVerify($event)"></altcha-widget>
  </div>
  <ng-template #templateApp>
    <div class="app-gbd" [class]="'lang-'+ms.lang">
      <router-outlet></router-outlet>
    </div>
  </ng-template>
</div>
<!--chatbot(*ngIf!="ms.isBeta")--><small class="logs" *ngIf="logsSettings.isExists" [class]="'align-' + logsSettings.align" [class.minimized]="logsSettings.minimize">
  <div class="buttons column">
    <div>
      <button (click)="setLogsSetting('align','left')" *ngIf="logsSettings.align=='right'">&larr;</button><span>&nbsp;&nbsp;LOGS TOOLS&nbsp;&nbsp;</span>
      <button (click)="setLogsSetting('align','right')" *ngIf="logsSettings.align=='left'">&rarr;</button>
    </div>
    <button (click)="setLogsSetting('minimize',true)">Minimize</button>
    <button (click)="logsSettings['isExists']=false" style="color:black">Hide all dev stuff</button>
    <label>
      <input type="checkbox" (click)="toggleDummyLogos($event)" [ngModel]="isDummyLogos"><span>&nbsp;Use dummy logos</span>
    </label>
    <pre>ms.isLoading : {{ms.isLoading}}</pre>
    <pre>ms.isLocalHost : {{ms.isLocalHost}}</pre>
    <pre>ms.endpoint : '{{ ms.endpoint }}'</pre>
    <pre>ms.lang : '{{ms.lang}}'</pre>
    <pre>ms.officeCC = '{{ms.officeCC}}'</pre>
    <pre>ms.searchError : {{ms.searchError | json}}</pre>
    <pre>ms.graphsRange.range : {{ms.graphsRange.range | json}}</pre>
    <pre>ps.prefs.layout : '{{ps.getPref("layout")}}</pre>
    <pre>ms.cachedSt13s : {{ms.cachedSt13s}}</pre>
    <pre>cs.isCaptchaEnabled = {{captchaService.isCaptchaEnabled}}</pre>
  </div>
  <pre data-test-id="queryParams">qs.queryParams.{{ms.endpoint}} : {{qs.queryParams[ms.endpoint] | json}}</pre>
  <pre>ps.preferences.chart : {{ ps.getPref("chart","graphs") | json}} </pre>
  <button class="restore" *ngIf="logsSettings.minimize" (click)="setLogsSetting('minimize',false)">&#8599;</button></small>
<w-block-ui [blocked]="ms.isLoading" title="Processing" text=""></w-block-ui>
